import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "Icon",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M19 11.2v-6A1.2 1.2 0 0 0 17.8 4H8.2A1.2 1.2 0 0 0 7 5.2V10M7 10V5.2H4.6A3.6 3.6 0 0 0 1 8.8v4.8a1.2 1.2 0 0 0 1.2 1.2h.6",
  stroke: "currentColor",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M1 10h2.4a1.2 1.2 0 0 0 1.2-1.2V5.2M4.6 14.2a1.8 1.8 0 1 0 3.6 0 1.8 1.8 0 0 0-3.6 0v0ZM14.2 14.2a1.8 1.8 0 1 0 3.6 0 1.8 1.8 0 0 0-3.6 0ZM10 14.8h2.4",
  stroke: "currentColor",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }